import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import TextField from "@material-ui/core/TextField"
import ArticleCard from "./article-card"
import Bar from "./bar"

import {
  articles,
  groups,
  categoriesForGroup,
  parseGuideFilters,
} from "../data/guides"

const Articles = () => {
  const [group, setGroup] = React.useState("All")
  const [category, setCategory] = React.useState("All")
  const [titleFilter, setTitleFilter] = React.useState("")

  React.useEffect(() => {
    const syncFilters = () => {
      const filters = parseGuideFilters(window.location.search)
      setGroup(filters.group)
      setCategory(filters.category)
    }
    syncFilters()
    window.addEventListener("popstate", syncFilters)
    return () => window.removeEventListener("popstate", syncFilters)
  }, [])

  const updateFilters = (nextGroup: string, nextCategory: string) => {
    setGroup(nextGroup)
    setCategory(nextCategory)
    const params = new URLSearchParams()
    if (nextGroup !== "All") params.set("group", nextGroup)
    if (nextCategory !== "All") params.set("category", nextCategory)
    window.history.pushState(
      null,
      "",
      window.location.pathname +
        (params.toString() ? "?" + params.toString() : "")
    )
  }

  const filteredArticles = articles.filter(
    article =>
      (group === "All" || article.group === group) &&
      (category === "All" || article.category === category) &&
      article.title.toLowerCase().includes(titleFilter.trim().toLowerCase())
  )

  return (
    <Grid container spacing={3} style={{ padding: "32px 0 48px" }}>
      <Grid item xs={12} style={{ textAlign: "center" }}>
        <Typography variant="h4" component="h1">
          Guides
        </Typography>
        <Bar />
        <Typography
          variant="subtitle1"
          style={{ margin: "24px auto", maxWidth: 680 }}
        >
          Find a use case for your week, learn how to use School Calendar, or
          explore music, sports, study routines, and evidence-informed study
          skills.
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="guide-group-label">Group</InputLabel>
          <Select
            labelId="guide-group-label"
            label="Group"
            value={group}
            onChange={event =>
              updateFilters(event.target.value as string, "All")
            }
          >
            {["All", ...groups].map(item => (
              <MenuItem value={item} key={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      {categoriesForGroup(group).length > 0 && (
        <Grid item xs={12} sm={4}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="routine-category-label">
              {group === "Study skills" ? "Type" : "Activity"}
            </InputLabel>
            <Select
              labelId="routine-category-label"
              label={group === "Study skills" ? "Type" : "Activity"}
              value={category}
              onChange={event =>
                updateFilters(group, event.target.value as string)
              }
            >
              {["All", ...categoriesForGroup(group)].map(item => (
                <MenuItem value={item} key={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
      <Grid item xs={12} sm={4}>
        <TextField
          label="Search guides"
          variant="outlined"
          fullWidth
          value={titleFilter}
          onChange={event => setTitleFilter(event.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          Showing {filteredArticles.length} of {articles.length} guides
        </Typography>
      </Grid>
      {groups.map(section => {
        const items = filteredArticles.filter(
          article => article.group === section
        )
        if (!items.length) return null
        return (
          <Grid item xs={12} key={section} component="section">
            <Typography variant="h5" component="h2" gutterBottom>
              {section}
            </Typography>
            <Grid container spacing={3}>
              {items.map(article => (
                <Grid item xs={12} sm={6} md={4} key={article.url}>
                  <ArticleCard article={article} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        )
      })}
      {!filteredArticles.length && (
        <Grid item xs={12}>
          <Typography>No guides match those filters.</Typography>
        </Grid>
      )}
    </Grid>
  )
}
export default Articles
